<template>
  <b-row>
    <b-col cols="12" md="4" class="mb-3 text-center">
      <TableLiquidationExtract
        :items="items1"
        :dropdownOptions="dropdownOptions"
        :selectedEC="selectedEC"
        :formattedFields="formattedFields"
        :loading="loadingTable"
        :rawTableData="rawTableData"
      />
    </b-col>

    <b-col cols="12" md="4" class="mb-3 text-center">
      <TableExtractTransaction
        :items="items2"
        :dropdownOptions="dropdownOptions"
        :selectedEC="selectedEC"
        :formattedFields="formattedFields"
        :loading="loadingTable"
        :rawTableData="rawTableData"
      />
    </b-col>

    <b-col cols="12" md="4" class="mb-3 text-center">
      <TableExtractValidation
        :items="items3"
        :dropdownOptionsExtract="dropdownOptionsExtract"
        :selectedEC="selectedEC"
        :formattedFields="formattedFields"
        :loading="loadingExtract"
        :rawExtractData="rawExtractData"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BModal } from "bootstrap-vue";
import TableLiquidationExtract from "./TableLiquidationExtract.vue";
import TableExtractValidation from "./TableExtractValidation.vue";
import TableExtractTransaction from "./TableExtractTransaction.vue";

export default {
  components: {
    BRow,
    BCol,
    BModal,
    TableLiquidationExtract,
    TableExtractValidation,
    TableExtractTransaction,
  },
  props: {
    items1: { type: Array, default: () => [] },
    items2: { type: Array, default: () => [] },
    items3: { type: Array, default: () => [] },
    dropdownOptions: { type: Array, default: () => [] },
    dropdownOptionsExtract: { type: Array, default: () => [] },
    selectedEC: String,
    loadingLiquidation: Boolean,
    loadingTable: Boolean,
    loadingExtract: Boolean,
    rawTableData: { type: Array, default: () => []},
    rawExtractData: { type: Array, default: () => []}
  },
  data() {
    return {
      fields: ["ec", "nome", "diferença"],
    };
  },
  computed: {
    formattedFields() {
      return this.fields.map((field) => {
        if (field === "diferença") {
          return {
            key: "diferença",
            label: "Diferença",
            formatter: this.formatCurrency,
            sortable: true,
          };
        }
        return {
          key: field,
          label: field,
          sortable: true,
        };
      });
    },
  },

  methods: {
    formatCurrency(value) {
      return value != null
        ? new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(value)
        : value;
    },
  },
};
</script>
